import { ColumnFiltersState } from "@tanstack/react-table"

const hasFiltersChanged = (newColumnFilters: ColumnFiltersState, columnFilters: ColumnFiltersState) => {
  return (
    newColumnFilters.length !== columnFilters.length ||
    newColumnFilters.some((newFilter, index) => {
      const oldFilter = columnFilters[index]
      return newFilter.id !== oldFilter.id || newFilter.value !== oldFilter.value
    })
  )
}

const getStickyColumnOffset = (index: number, stickyHeaders: any[], sticky?: string) => {
  const stickyIndex = stickyHeaders.findIndex((val) => val?.index === index)
  if (sticky === "left") {
    if (stickyIndex == 0) return "0px"
    const offset = stickyHeaders.slice(0, stickyIndex).reduceRight((acc, header) => {
      return acc + (parseInt(header?.width) ?? 0)
    }, 0)
    return `${offset}px`
  } else if (sticky === "right") {
    if (stickyHeaders.length - 1 === stickyIndex) return "0px"
    const offset = stickyHeaders.slice(stickyIndex + 1).reduce((acc, header) => {
      return acc + (parseInt(header?.width) ?? 0)
    }, 0)
    return `${offset}px`
  }
  return "0px"
}

export { hasFiltersChanged, getStickyColumnOffset }
